import {
  type MealTypeValues,
  ORDERED_MEALTYPES,
  ORDERED_MEMBER_RATES,
  STANDARD_ROOMS,
} from 'lumen/utils/constants/general-constants';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function sortRoomtypeIds(roomtypeA: string, roomtypeB: string) {
  if (roomtypeA.indexOf('c_') !== -1) {
    if (roomtypeB.indexOf('c_') !== -1) {
      // id is `c_<number>`, the number is higher if it's created later
      const idNumberA = parseInt(roomtypeA.replace('c_', ''), 10);
      const idNumberB = parseInt(roomtypeB.replace('c_', ''), 10);
      return idNumberA - idNumberB;
    }
    return 1;
  }

  if (roomtypeB.indexOf('c_') !== -1) {
    return -1;
  }

  return STANDARD_ROOMS.indexOf(roomtypeA) > STANDARD_ROOMS.indexOf(roomtypeB)
    ? 1
    : -1;
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function sortMealtypeIds(
  mealtypeA: MealTypeValues,
  mealtypeB: MealTypeValues,
) {
  const indexOfA = ORDERED_MEALTYPES.indexOf(mealtypeA);
  const indexOfB = ORDERED_MEALTYPES.indexOf(mealtypeB);

  // Sort ascending
  if (indexOfA === -1) {
    return 1;
  }

  if (indexOfB === -1) {
    return -1;
  }

  return indexOfA - indexOfB;
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function sortMembershipTypeIds(
  membershipA: string,
  membershipB: string,
) {
  const indexOfA = ORDERED_MEMBER_RATES.indexOf(membershipA);
  const indexOfB = ORDERED_MEMBER_RATES.indexOf(membershipB);

  // Sort ascending
  if (indexOfA === -1) {
    return 1;
  }

  if (indexOfB === -1) {
    return -1;
  }

  return indexOfA - indexOfB;
}
